module.exports = __webpack_public_path__ + "img/智慧煤矿2.ef68b19d.png";